import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { HiArrowRight, HiArrowDown } from "react-icons/hi";
import { VscDebugBreakpointLog } from "react-icons/vsc";
import { Link } from 'react-router-dom';
import * as FaIcons from "react-icons/fa";
import * as MdIcons from "react-icons/md";

// Map icon names to actual components
const iconMap = {
  FaGlobe: FaIcons.FaGlobe,
  FaMobileAlt: FaIcons.FaMobileAlt,
  MdDashboard: MdIcons.MdDashboard,
  FaSearch: FaIcons.FaSearch,
  FaTools: FaIcons.FaTools,
};

const getIconComponent = (iconName) => {
  if (!iconName) return FaIcons.FaCog; // default icon
  const Icon = iconMap[iconName];
  return Icon ? Icon : FaIcons.FaCog;
};

const Card = ({ service }) => {
  const { t, i18n } = useTranslation();
  const [isExpanded, setIsExpanded] = useState(false);
  const { id, title, description, features, slug, icon } = service;

  const featureList = features ? features.map(f => f.feature) : [];
  const IconComponent = getIconComponent(icon);

  return (
    <div className="w-full px-4 h-auto min-h-[320px] py-10 pt-0 lg:pt-10 rounded-lg shadow-shadowOne flex items-center bg-gradient-to-r from-bodyColor to-[#202327] group hover:bg-gradient-to-b hover:from-black hover:to-[#1e2024] transition-all duration-300 group card-border">
      <div className={`h-full w-full transition-all duration-300 ${isExpanded ? 'overflow-visible' : 'overflow-y-hidden'}`}>
        <div className={`flex flex-col gap-6 lg:gap-8 transition-all duration-300 ${isExpanded ? 'translate-y-0' : 'lg:group-hover:translate-y-0 translate-y-16'}`}>
          <div className="flex items-start justify-between">
            <div className="w-10 h-8 flex flex-col justify-between">
              <IconComponent className="text-5xl text-designColor" />
            </div>
            <span className="text-2xl mt-[14px] md:mt-[14px] lg:mt-0 text-designColor md:block lg:hidden">
              <Link onClick={() => window.scrollTo(0,0)} to={`/service/${slug}`}>
                {isExpanded ? <HiArrowDown /> : <HiArrowRight />}
              </Link>
            </span>
          </div>

          <div className="flex flex-col gap-4 lg:gap-6">
            <h2 className="text-xl md:text-2xl font-titleFont font-bold text-gray-300">
              {title}
            </h2>
            <ul className={`space-y-2 transition-all duration-300 ${isExpanded ? 'max-h-[500px]' : 'max-h-[120px] overflow-hidden'}`}>
              {featureList.map((feature, index) => (
                <li key={index} className='flex items-start'>
                  <VscDebugBreakpointLog className={`flex-shrink-0 mt-1 ${i18n.language === 'en' ? 'mr-2' : 'ml-2'} text-[#ff014f] point-box`} />
                  <span className="text-sm md:text-base">{feature}</span>
                </li>
              ))}
            </ul>
          </div>

          <button
            onClick={() => setIsExpanded(!isExpanded)}
            className="md:hidden flex items-center justify-center gap-2 text-designColor py-2 px-4 rounded-lg bg-[#1e2024] bg-opacity-50 hover:bg-opacity-70 transition-all duration-200"
          >
            {isExpanded ? 'Show Less' : 'Show More'}
            {isExpanded ? <HiArrowDown /> : <HiArrowRight />}
          </button>

          <span className="hidden lg:block text-2xl text-designColor mt-2 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
            {/* <Link onClick={() => window.scrollTo(0,0)} to={`/service/${slug}`}> */}
              <HiArrowRight />
            {/* </Link> */}
          </span>
        </div>
      </div>
    </div>
  );
};

export default Card;